import { FC } from 'react';

import { Row } from 'antd';
import { useAppSelector } from 'hooks/redux';
import { getText } from 'utils/stringUtil';
import {
  ITS_QUIET_IN_HERE,
  NO_DISCLOSURES_MESSAGE,
} from 'constants/languageConstants';
import notebookIcon from 'images/icons/notebook.svg';

import styles from './noDisclosureView.module.less';

type NoPlansViewProps = {
  className?: string;
};

const NoDisclosureView: FC<NoPlansViewProps> = ({
  className,
}: NoPlansViewProps) => {
  const language = useAppSelector((state) => state.benguide.data?.language);

  return (
    <div className={styles.containedDiv}>
      <div className={`${styles.noPlansWrapper} ${className}`}>
        <Row className={styles.detailWrapper}>
          <img src={notebookIcon} alt="edit" />
        </Row>
        <Row className={styles.header}>
          {getText(ITS_QUIET_IN_HERE, language)}
        </Row>
        <Row className={styles.subHeader}>
          {getText(NO_DISCLOSURES_MESSAGE, language)}
        </Row>
      </div>
    </div>
  );
};

export default NoDisclosureView;
